<template>
      <template v-if="adblockDetected">
        <div class="adblockBackground">
              <div class="adblockWrapper d-flex flex-column justify-content-center align-items-center">
                  <div class="adblockInfoBox">
                      <div class="adblockIcon mb-4">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>
                      </div>
                      <div class="adblockTitle mb-4">
                        Technologia, której używamy aby naliczać darowizny od zakupów online, jest blokowana przez rozszerzenia typu AdBlock, uBlock, ghostery oraz w oknach prywatnych / incognito niektórych przeglądarek.
                      </div>
                      <div class="adblockInfo mb-4">
                        Ważne! Dodanie fanimani.pl do wyjątków czy białej listy jest niewystarczające. Niezbędne jest wyłączenie adblocka albo zmiana okna przeglądarki. <a href="https://fanimani.pl/pomoc/dla-uzytkownika/przypominajka/blokery/adblock/" target="_blank">Więcej informacji</a>
                      </div>
                      <div class="adblockButton" v-on:click="adblockRefresh()">
                        wyłącz adblocka / zmień okno przeglądarki na czas zakupów i odśwież stronę
                      </div>
                      <div class="text-center mt-4" v-on:click="adblockForce()">
                        <span class="adblockButtonSmall">chcę przejść do sklepu mimo wszystko</span>
                      </div>
                  </div>
              </div>
              <div class="adblockMessage">
                  Nie masz adblocka? <a href="https://fanimani.pl/pomoc/wiadomosc/" target="_blank">Wyślij nam wiadomość</a>
              </div>
          </div>
    </template>
    <template v-else>
        <div class="ext-partner-redir" id="ext-partner-redir">
            <template v-if="speedbumpDisplayed">
                <template v-if="partner.id==bookmarkPartner">
                    <div class="partner-modal-partner-logo">
                        <img :src="partner.thumbnail_url" :alt="partner.name" />
                    </div>

                    <template v-if="bookmarkStep1">
                        <p>
                            Na Booking.com Przypominajka FaniMani nie<br>wyświetla się automatycznie.<br><strong>Na szczęście nadal możesz wspierać wybraną<br>organizację przy okazji rezerwacji noclegu ❤️</strong>
                        </p>
                        <p>
                            Aby ułatwić pomaganie przygotowaliśmy dla<br>Ciebie specjalny link.
                        </p>
                        <button class="btn btn-red" v-on:click="bookmarkGoToStep2()">Dodaj do Ulubionych</button>
                        <a :href=redirectUrl class="partner-modal-outside-link" v-on:click="speedbumpAcknowledge($event)">Dziękuję, przechodzę do Booking.com</a>
                    </template>
                    <template v-if="bookmarkStep2">
                        <p>⭐ Kliknij ikonę gwiazdki w pasku adresu<br>przeglądarki (na samej górze) lub na klawiaturze<br>użyj skrótu: Ctrl + D (Cmd + D na Macu).</p>
                        <a :href=redirectUrl class="btn btn-red" v-on:click="speedbumpAcknowledge($event)">Dodane. Przejdź do Booking.com</a>
                    </template>
                </template>
                <template v-else>
                    <div class="partner-redir-speedbump">
                        <div class="partner-redir-speedbump__card">
                            <img v-if="!apiError" class="partner-redir-speedbump__logo" :src="partner.thumbnail_url" :alt="partner.name" />

                            <h2 class="partner-redir-speedbump__title">Zanim przejdziesz na stronę {{ partner.name }}</h2>

                            <div class="partner-redir-speedbump__note" v-html="speedbumpDescription"></div>

                            <a :href="redirectUrl" class="partner-redir-speedbump__cta" v-on:click="speedbumpAcknowledge($event)">
                                Rozumiem, przechodzę do sklepu
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            </a>
                        </div>
                    </div>
                </template>
            </template>
            <template v-if="!speedbumpDisplayed">
                <div class="partner-redir-loading">
                    <div class="partner-redir-loading__inner" v-if="!apiError">
                        <div class="partner-redir-loading__content" v-if="infoFetched && partner">
                            <img class="partner-redir-loading__logo" :src="partner.thumbnail_url" :alt="partner.name" />

                            <p class="partner-redir-loading__headline">
                                Kupując w {{ partner.name }} wybrana przez Ciebie organizacja otrzyma<br>
                                <span class="partner-redir-loading__headline-accent" v-html="partner.donation_value_full_html"></span> wartości zakupów
                            </p>

                            <div class="partner-redir-loading__org"
                                 v-if="beneficiary && beneficiary.id != 10 && beneficiary.logo_url">
                                <img class="partner-redir-loading__org-logo" :src="beneficiary.logo_url" :alt="beneficiary.name" />
                                <div class="partner-redir-loading__org-info">
                                    <span class="partner-redir-loading__org-label">Wspierasz</span>
                                    <span class="partner-redir-loading__org-name">{{ beneficiary.name }}</span>
                                </div>
                            </div>

                            <p class="partner-redir-loading__org-fallback" v-else>
                                Darowizna trafi do wybranej organizacji.
                            </p>

                            <p class="partner-redir-loading__note" v-if="redirPage === 'mobile'">
                                W sklepie nie będzie widoczna informacja o aktywnej darowiźnie.
                            </p>

                            <p class="partner-redir-loading__footnote" v-if="partner.fm_ext_footnote">
                                {{ partner.fm_ext_footnote }}
                            </p>
                        </div>

                        <svg class="partner-redir__spinner" role="status" aria-label="Przygotowujemy przejście do sklepu" xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 36 38"><path fill="currentColor" d="M18.75 0a3.91 3.91 0 0 0-3.906 3.906 3.91 3.91 0 0 0 3.906 3.907 3.91 3.91 0 0 0 3.906-3.907A3.91 3.91 0 0 0 18.75 0m11.084 3.809a4.689 4.689 0 0 0 0 9.375 4.689 4.689 0 0 0 0-9.375M7.714 4.932a3.517 3.517 0 0 0 0 7.03 3.517 3.517 0 0 0 0-7.03M3.126 16.406A3.123 3.123 0 0 0 0 19.531a3.123 3.123 0 0 0 3.125 3.125 3.123 3.123 0 0 0 3.125-3.125 3.123 3.123 0 0 0-3.125-3.125m31.25 1.563c-.86 0-1.562.702-1.562 1.562s.701 1.563 1.562 1.563c.86 0 1.563-.702 1.563-1.563 0-.86-.702-1.562-1.563-1.562M7.666 27.832a2.74 2.74 0 0 0-2.734 2.734 2.74 2.74 0 0 0 2.734 2.735 2.74 2.74 0 0 0 2.734-2.735 2.74 2.74 0 0 0-2.734-2.734m21.729.83c-.892.183-1.563 1.007-1.563 1.953 0 1.08.873 1.953 1.953 1.953s1.953-.872 1.953-1.953-.872-1.953-1.953-1.953c-.134 0-.262-.024-.39 0m-10.645 4.15a2.344 2.344 0 1 0 .001 4.69 2.344 2.344 0 0 0-.001-4.69"/></svg>
                    </div>

                    <div class="partner-redir-loading__error" v-if="apiError === 404">
                        <p>Wybrany przez Ciebie sklep jest obecnie niedostępny w FaniMani.</p>
                        <a href="/sklepy/" class="btn btn-red">Wybierz inny sklep <span class="fa fa-chevron-right"></span></a>
                    </div>
                    <div class="partner-redir-loading__error" v-else-if="apiError">
                        <p>Coś poszło nie tak. Wróć do sklepu i aktywuj darowiznę jeszcze raz.</p>
                        <p>
                            Jeśli ten problem będzie się&nbsp;powtarzał, powiadom&nbsp;nas o&nbsp;tym e-mailowo na&nbsp;adres:
                            <a href="mailto:info@fanimani.pl"><strong>info@fanimani.pl</strong></a>.
                        </p>
                    </div>
                </div>
            </template>
        </div>
    </template>
</template>

<script>
    window.clickthrough={
        partner: null,
        beneficiary: null
      };

    import 'whatwg-fetch'
      import Cookies from 'js-cookie'
      import queryString from 'query-string'
      import Vue from 'vue'

    function getDefaultHeaders () {
        let headers = new Headers()
        headers.append('Accept', 'application/json')
        headers.append('Content-Type', 'application/json')
        headers.append('X-CSRFToken', Cookies.get('csrftoken'))
        return headers
    }

    export default {
        name: 'ext-redir-page',
        data: function () {
            return {
                apiError: false,
                infoFetched: false,
                infoFetching: true,
                speedbumpDisplayed: false,
                speedbumpItems: [],
                speedbumpDescription: '',
                partner: null,
                beneficiary: null,
                redirectUrl: false,
                redirPage,
                user: null,
                staticUrl: window.FM.STATIC_URL || '',
                bookmarkStep1: false,
                bookmarkStep2: false,
                bookmarkButton: (navigator.userAgent.toLowerCase().indexOf('mac') != -1 ? 'CMD' : 'CTRL'),
                bookmarkPartner: 937,
                utm_campaign: null,
                adblockDetected: false,
                adblockForced: false
            }
        },
        methods: {
            adblockDetect: async() => {
                const baitUrls = [
                    //'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
                    //'https://connect.facebook.net/pl_PL/fbevents.js',
                    //'https://c.amazon-adsystem.com/e/dtb/bid',
                    //'https://www.googletagservices.com/tag/js/gpt.js',
                    //'https://static.hotjar.com/c/hotjar-0.js',
                    //'https://cdn.branch.io/branch-latest.min.js',
                    'https://adblock.fanimani.pl/adserwer.js'
                ];

                for (const baitUrl of baitUrls) {
                    try {
                        const response = await fetch(baitUrl, {
                        method: 'HEAD',
                        mode: 'no-cors',
                        cache: 'no-store'
                    });
                    } catch (error) {
                        //console.log('not loaded')
                        const response = fetch("https://adblock.fanimani.pl/log/", {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            'browser': window.navigator.userAgent,
                            'url': baitUrl
                        })
                        });
                        return true;
                    }
                }
            },
            fetchRedirectInfo: function () {
                // Pick partner and deep link from url and convey them to API
                let { partner, destination, beneficiary_id, utm_source, utm_medium, utm_campaign } = queryString.parse(location.search)
                let url = '/api/v2/partner-redirect-info/' + partner + '/'
                let redirReqParams = queryString.stringify({destination, beneficiary_id})
                if (redirReqParams) {
                    url = url + '?' + redirReqParams
                }

                if(utm_source){
                    Cookies.set('utm_source', utm_source);
                }
                if(utm_medium){
                    Cookies.set('utm_medium', utm_medium);
                }

                if(utm_campaign){
                    Cookies.set('utm_campaign', utm_campaign);
                    this.utm_campaign = utm_campaign;
                }

                this.infoFetching = true
                return fetch(url, {
                    credentials: 'include',
                    headers: getDefaultHeaders()
                }).then(response => {
                    // Check status and throw error if not 200-ish
                    if (response.status >= 200 && response.status < 300) {
                        return response
                    } else {
                        let error = new Error(response.status + ": " + response.statusText)
                        error.response = response
                        throw error
                    }
                })
                .then(response => {
                    // And if there's no error, then return JSON
                    console.log('Will return json')
                    return response.json()
                })
                .catch(ex => {
                    this.infoFetching = false
                    this.infoFetched = false
                    this.apiError = true
                    console.log('fetching or parsing failed', ex)
                    throw ex
                })
            },
            adblockRefresh: function () {
                window.location.reload();
            },
            adblockForce: function(){
                this.adblockDetected = false;
                this.adblockForced = true;
                this.fetchRedirectInfo()
                .then(data => {
                    this.shopclickHandle(data);
                })
                .catch(error => {
                    this.apiError = true
                    this.infoFetching = true
                    if (error.response && error.response.status) {
                        this.apiError = error.response.status
                    }
                })
            },
            redirectToPartner: function (timeout=2000) {
                let { debug } = queryString.parse(location.search)
                // wait 2 secs and redirect to shop
                var this2=this;
                this.postClickthroughData();

                if(typeof(debug)=='undefined'){
                setTimeout(function () {
                    console.log("Redirecting to shop... " + this2.redirectUrl)
                    window.location = encodeURI(this2.redirectUrl)
                }, timeout)
                }
            },

            speedbumpAcknowledge: function(event){
                event.preventDefault();
                Cookies.set('partner_'+this.partner.id+'_speedbump', 1, { expires: 7 })
                clickthrough['partner_id']=this.partner.id;
                clickthrough['partner']=this.partner;
                clickthrough['beneficiary']=this.beneficiary;
                clickthrough['user']=this.user;
                this.redirectToPartner(100);
            },

            postClickthroughData: function(){
                try{
                    window.postMessage(
                        {
                            action: "fanimaniExtensionClickthrough",
                            data: JSON.parse(JSON.stringify(clickthrough))
                        }, "*"
                    );
                } catch(e){
                    console.log('postClickthroughData() error')
                    console.log(e)
                    console.log(JSON.parse(JSON.stringify(clickthrough)))
                }
            },

            bookmarkGoToStep2: function(event){
                document.body.classList.add('partner-modal-bookmark-step2');
                try{
                    let bookmarkUrl = new URL(window.location.href);
                    bookmarkUrl.searchParams.set('utm_campaign', 'bookmark');
                    history.pushState({}, "", bookmarkUrl);
                } catch (e) {
                    console.log('bookmarkGoToStep2() error');
                }
                this.bookmarkStep1 = false;
                this.bookmarkStep2 = true;
            },
            shopclickHandle: function(data){
                // FIXME: For some reason this handler gets called also if the promose resulted with an error
                // So exit programatically if there's no data (was error)
                if (typeof(data) === 'undefined') {
                    return
                }

                let { debug } = queryString.parse(location.search)

                if(typeof(debug)!='undefined'){
                    console.log('fetchRedirectInfo():');
                    console.log(data);
                }

                this.partner = data.partner
                this.beneficiary = data.beneficiary
                this.user = data.user

                this.infoFetched = true
                this.infoFetching = false

                this.redirectUrl = data.redirect_url

                if(this.partner){
                    document.title=this.partner.name+' - AKTYWUJ DAROWIZNĘ - FaniMani.pl';
                }

                if(data.partner.speedbump_visible){
                    var speedbumpCookie=Cookies.get('partner_'+data.partner.id+'_speedbump');
                    if(speedbumpCookie || this.utm_campaign=='bookmark' || (redirPage=='mobile' && data.partner.id==this.bookmarkPartner)){
                        clickthrough['partner_id']=this.partner.id;
                        clickthrough['partner']=this.partner;
                        clickthrough['beneficiary']=this.beneficiary;
                        clickthrough['user']=this.user;
                        this.redirectToPartner();
                    } else {
                        if(data.partner.id==this.bookmarkPartner){
                            this.bookmarkStep1 = true;
                        }
                        this.speedbumpDisplayed = true;
                        this.speedbumpItems = data.partner.speedbump_description.split(/\r\n|\n|\r/);
                        this.speedbumpDescription = data.partner.speedbump_description;
                    }
                } else {
                    clickthrough['partner_id']=this.partner.id;
                    clickthrough['partner']=this.partner;
                    clickthrough['beneficiary']=this.beneficiary;
                    clickthrough['user']=this.user;
                    this.redirectToPartner();
                }
            }
        },
        mounted: function () {
            this.adblockDetect().then((adblockDetectResults) => {
                if(adblockDetectResults){
                    this.adblockDetected = true;
                    console.log('adblock detected')
                } else {
                    console.log('adblock not detected')
                    this.fetchRedirectInfo()
                    .then(data => {
                        this.shopclickHandle(data);
                    })
                    .catch(error => {
                        this.apiError = true
                        this.infoFetching = true
                        if (error.response && error.response.status) {
                            this.apiError = error.response.status
                        }
                    })
                }
            });
        }
    }
</script>

<style>
    .partner-redir-loading {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: 1100;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
        background-color: #ffffff;
        box-sizing: border-box;
        font-family: 'DMSans', 'Helvetica Neue', Arial, sans-serif;
    }

    .partner-redir-loading .partner-redir-loading__inner {
        position: relative;
        width: 100%;
        max-width: 900px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
    }

    .partner-redir-loading .partner-redir-loading__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 32px;
        width: 100%;
        opacity: 0.4;
    }

    .partner-redir-loading .partner-redir-loading__logo {
        width: 200px;
        height: 117px;
        max-width: 100%;
        object-fit: contain;
        margin: 0;
    }

    .partner-redir-loading .partner-redir-loading__headline {
        margin: 0;
        padding: 0;
        max-width: 100%;
        font-family: 'Parkinsans', 'Helvetica Neue', Arial, sans-serif;
        font-weight: 400;
        font-size: 28px;
        line-height: 1.2;
        color: #22252a;
        text-align: center;
        text-wrap: balance;
    }

    .partner-redir-loading .partner-redir-loading__headline-accent {
        color: #e40148;
        font-weight: 400;
        white-space: nowrap;
    }

    .partner-redir-loading .partner-redir-loading__org {
        display: flex;
        align-items: center;
        gap: 40px;
        width: 588px;
        max-width: 100%;
        min-height: 109px;
        background: #ffffff;
        border: 2px solid #f1f3f6;
        border-radius: 20px;
        padding: 14px 22px;
        box-sizing: border-box;
    }

    .partner-redir-loading .partner-redir-loading__org-logo {
        width: 104px;
        height: 61px;
        max-width: none;
        object-fit: contain;
        flex-shrink: 0;
        margin: 0;
    }

    .partner-redir-loading .partner-redir-loading__org-info {
        display: flex;
        flex-direction: column;
        gap: 2px;
        text-align: left;
    }

    .partner-redir-loading .partner-redir-loading__org-label {
        font-family: 'DMSans', 'Helvetica Neue', Arial, sans-serif;
        font-size: 14px;
        line-height: 1.2;
        color: #22252a;
    }

    .partner-redir-loading .partner-redir-loading__org-name {
        font-family: 'Parkinsans', 'Helvetica Neue', Arial, sans-serif;
        font-weight: 500;
        font-size: 16px;
        line-height: 1.4;
        color: #22252a;
    }

    .partner-redir-loading .partner-redir-loading__org-fallback,
    .partner-redir-loading .partner-redir-loading__note {
        margin: 0;
        padding: 0;
        font-family: 'DMSans', 'Helvetica Neue', Arial, sans-serif;
        font-size: 16px;
        line-height: 1.6;
        color: #22252a;
        text-align: center;
    }

    .partner-redir-loading .partner-redir-loading__footnote {
        margin: 0;
        padding: 0;
        font-family: 'DMSans', 'Helvetica Neue', Arial, sans-serif;
        font-size: 14px;
        line-height: 1.6;
        color: #9096a3;
        text-align: center;
    }

    .partner-redir-loading .partner-redir-loading__error {
        text-align: center;
    }

    .partner-redir-loading .partner-redir__spinner {
        width: 40px;
        height: 40px;
        color: #e40148;
        display: block;
        animation: partner-redir-spin 1.8s linear infinite;
    }

    @keyframes partner-redir-spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    @media only screen and (max-width: 600px) {
        .partner-redir-loading .partner-redir-loading__logo {
            width: 154px;
            height: 90px;
        }
        .partner-redir-loading .partner-redir-loading__headline {
            font-size: 24px;
        }
        .partner-redir-loading .partner-redir-loading__org {
            flex-direction: column-reverse;
            gap: 16px;
            padding: 24px;
            text-align: center;
        }
        .partner-redir-loading .partner-redir-loading__org-info {
            align-items: center;
        }
    }

    .partner-redir-speedbump {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: 1100;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
        box-sizing: border-box;
        background-color: #ffffff;
        overflow-y: auto;
        font-family: 'DMSans', 'Helvetica Neue', Arial, sans-serif;
    }

    .partner-redir-speedbump .partner-redir-speedbump__card {
        width: 100%;
        max-width: 560px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 28px;
    }

    .partner-redir-speedbump .partner-redir-speedbump__logo {
        width: 160px;
        height: 94px;
        max-width: 100%;
        object-fit: contain;
        margin: 0;
    }

    .partner-redir-speedbump .partner-redir-speedbump__title {
        margin: 0;
        padding: 0;
        max-width: 100%;
        font-family: 'Parkinsans', 'Helvetica Neue', Arial, sans-serif;
        font-weight: 400;
        font-size: 28px;
        line-height: 1.2;
        color: #22252a;
        text-align: center;
        text-wrap: balance;
    }

    .partner-redir-speedbump .partner-redir-speedbump__note {
        width: 100%;
        box-sizing: border-box;
        background: #f8f9fb;
        border-radius: 20px;
        padding: 24px 28px;
        text-align: left;
        color: #22252a;
        font-family: 'DMSans', 'Helvetica Neue', Arial, sans-serif;
        font-size: 15px;
        line-height: 1.6;
    }

    .partner-redir-speedbump .partner-redir-speedbump__note p {
        margin: 0 0 12px;
        font-family: 'DMSans', 'Helvetica Neue', Arial, sans-serif;
        line-height: 1.6;
    }

    .partner-redir-speedbump .partner-redir-speedbump__note p:last-child {
        margin-bottom: 0;
    }

    .partner-redir-speedbump .partner-redir-speedbump__note ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .partner-redir-speedbump .partner-redir-speedbump__note li {
        position: relative;
        padding-left: 24px;
    }

    .partner-redir-speedbump .partner-redir-speedbump__note li::before {
        content: "";
        position: absolute;
        left: 6px;
        top: 9px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #e40148;
    }

    .partner-redir-speedbump .partner-redir-speedbump__cta {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        height: 48px;
        padding: 0 28px;
        box-sizing: border-box;
        background: #e40148;
        color: #ffffff;
        border: none;
        border-radius: 20px;
        font-family: 'DMSans', 'Helvetica Neue', Arial, sans-serif;
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;
        text-decoration: none;
        cursor: pointer;
        transition: background-color 0.2s ease-in-out;
    }

    .partner-redir-speedbump .partner-redir-speedbump__cta:hover {
        background: #c10039;
    }

    @media only screen and (max-width: 600px) {
        .partner-redir-speedbump .partner-redir-speedbump__logo {
            width: 140px;
            height: 82px;
        }
        .partner-redir-speedbump .partner-redir-speedbump__title {
            font-size: 24px;
        }
        .partner-redir-speedbump .partner-redir-speedbump__note {
            padding: 20px;
        }
    }
</style>
